import { render } from "./MultiInput.vue?vue&type=template&id=22c6377c&scoped=true"
import script from "./MultiInput.vue?vue&type=script&lang=js"
export * from "./MultiInput.vue?vue&type=script&lang=js"

import "./MultiInput.vue?vue&type=style&index=0&id=22c6377c&scoped=true&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0add72b42d7a2609c-1/assemble-sports/unisports-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6377c"]])

export default __exports__